import { useState } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { getStorageItem } from '../../../../utils/storage'
import {
  NEWSBOARD_POST_HIDE_WELCOME_POST_STORAGE_NAME,
  NEWSBOARD_WELCOME_CUSTOM_POST_TYPE,
} from '../../../Newsboard'
import { getWelcomePost } from '../../Posts.api'

export function useWelcomePost() {
  const [welcomePost, setWelcomePost] = useState(EMPTY_OBJECT)
  const [hideWelcomePost, setHidePost] = useState(false)
  const hiddenWelcomePostStorageValue = getStorageItem(
    NEWSBOARD_POST_HIDE_WELCOME_POST_STORAGE_NAME
  )

  function handleLoadWelcomePost() {
    if (!hiddenWelcomePostStorageValue) {
      getWelcomePost().then(({ data }) => {
        setWelcomePost({
          ...data,
          post_type: { title: NEWSBOARD_WELCOME_CUSTOM_POST_TYPE },
        })
      })
    }
  }

  function handleHideWelcomePost() {
    setHidePost(true)
  }

  return {
    handleHideWelcomePost,
    handleLoadWelcomePost,
    hideWelcomePost: hideWelcomePost || hiddenWelcomePostStorageValue,
    welcomePost,
  }
}
